const varluxDemoCategories = {
    INSTANT: "GPS",
    SHARP: "LIVRE",
    STABILIZED: "STAIRS",
    EXTENDED: "TABLETTE",
    PANOROMIC: "TROTT"
}
export default varluxDemoCategories;